var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs-items', {
    staticClass: "h-100 scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "value": _vm.tab,
      "touchless": ""
    }
  }, [_c('tab-disabled', _vm._b({
    attrs: {
      "tabValue": _vm.TABS.DISABLED
    },
    scopedSlots: _vm._u([{
      key: "tab-complete-actions",
      fn: function () {
        return [_vm._t("tab-complete-actions")];
      },
      proxy: true
    }], null, true)
  }, 'tab-disabled', {
    meeting: _vm.meeting
  }, false)), _c('tab-schedule', _vm._g(_vm._b({
    attrs: {
      "tabValue": _vm.TABS.SCHEDULE
    },
    model: {
      value: _vm.schedule.date,
      callback: function ($$v) {
        _vm.$set(_vm.schedule, "date", $$v);
      },
      expression: "schedule.date"
    }
  }, 'tab-schedule', {
    meeting: _vm.meeting,
    schedule: _vm.schedule,
    loading: _vm.loading
  }, false), {
    save: _vm.save
  })), _c('tab-complete', _vm._g(_vm._b({
    attrs: {
      "tabValue": _vm.TABS.COMPLETE
    },
    scopedSlots: _vm._u([{
      key: "tab-complete-actions",
      fn: function () {
        return [_vm._t("tab-complete-actions")];
      },
      proxy: true
    }], null, true)
  }, 'tab-complete', {
    meeting: _vm.meeting,
    schedule: _vm.schedule
  }, false), {
    prev: _vm.prev
  })), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tab == _vm.TABS.LOADING,
      expression: "tab == TABS.LOADING"
    }],
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }